import { Controller } from "@hotwired/stimulus"

// Disables a button after it's clicked and toggles a loading ellipsis.
export default class extends Controller {
  static targets = ["label", "loader"]
  static values = {
    disabledClass: { type: String, default: "opacity-60 cursor-not-allowed" }
  }

  activate(event) {
    if (this.element.disabled) return

    this.showLoader()

    // Delay disabling until after the click default action submits the form.
    requestAnimationFrame(() => {
      this.disableButton()
    })
  }

  showLoader() {
    if (this.hasLabelTarget) {
      this.labelTarget.classList.add("hidden")
    }

    if (this.hasLoaderTarget) {
      this.loaderTarget.classList.remove("hidden")
      this.loaderTarget.classList.add("flex")
    }
  }

  disableButton() {
    this.element.disabled = true
    this.applyDisabledClasses()
  }

  applyDisabledClasses() {
    const classes = this.disabledClassValue.split(" ")

    classes.forEach((className) => {
      if (className.trim().length > 0) {
        this.element.classList.add(className.trim())
      }
    })
  }
}
